enum RiskFactorCategoryCode {
    Tobacco = "Tobacco",
    Alcohol = "Alcohol",
    Drugs = "Drugs",
    Coffee = "Coffee",
    MaritalStatus = "MaritalStatus",
    Job = "Job",
    Sports = "Sports",
    Diet = "Diet",
    Food = "Food",
    BreastFeeding = "BreastFeeding",
    BloodDonation = "BloodDonation",
    Medications = "Medications",
    Ostomy = "Ostomy",
    ContactLenses = "ContactLenses"
}

class RiskFactorCode {
    public Id: string;
    public VocabularyResourceKey: string;
    public Category: RiskFactorCategoryCode;
    public CategoryId: number;
    public Code: string;
    public Position: number;
}

export { RiskFactorCategoryCode, RiskFactorCode };
